<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12">
                <v-row no-gutters cols="12" class="my-3 justify-center">
                    <v-col cols="2">
                        <v-btn-primary
                            block
                            @click="$router.push({ name: 'new-operatingAccountSheet' })"
                        >
                            Ajouter
                        </v-btn-primary>
                        <!-- <v-menu
                            open-on-hover
                            bottom
                            offset-y
                        >
                            <template v-slot:activator="{ on, props }">
                                <v-btn

                                    color="secondary"
                                    v-bind="props"
                                    v-on="on"
                                    block
                                    height="40px"
                                    elevation="0"
                                    class="rounded-lg gradient"
                                    @click="$router.push({ name: 'new-operatingAccountSheet' })"
                                >
                                    Nouveau
                                </v-btn>
                            </template>

<v-list nav>
    <v-list-item @click="$router.push({ name: 'new-operatingAccountSheet' })">
        <v-list-item-title>A partir du SIG</v-list-item-title>
        <template v-slot:append>
                                        <v-icon  size=“x-small”>$fa-chevron-right</v-icon>
                                    </template>
    </v-list-item>
    <v-list-item>
        <v-list-item-title>A partir du compte de résultat</v-list-item-title>
        <template v-slot:append>
                                        <v-icon  size=“x-small”>$fa-chevron-right</v-icon>
                                    </template>
    </v-list-item>
    <v-list-item>
        <v-list-item-title>A partir du Bilan</v-list-item-title>
        <template v-slot:append>
                                        <v-icon  size=“x-small”>$fa-chevron-right</v-icon>
                                    </template>
    </v-list-item>
</v-list>
</v-menu> -->
                    </v-col>
                    <v-col cols="10" class="pl-2">
                        <v-text-field
                            v-model="search"
                            append-inner-icon="$search"
                            clearable
                            @click:clear="search = ''"
                            label="Recherche"
                            hide-details
                            density="compact"
                        />
                    </v-col>
                    <!-- <v-col cols="2" class="pl-2">
                        <v-combobox
                            v-model="filterCompany"
                            :items="allAvailableCompanies"
                            label="Société"
                            hide-details
                        >
                        </v-combobox>
                    </v-col> -->
                </v-row>
            </v-col>
            <RuleTable
                :rule="'operatingAccount'"
                :items="items"
                :wordingFunction="getWording"
                :hideDuplication="true"
                :accountingCompanyId="companyId"
                :pagination="pagination"
                :patternCount="operatingAccountCount"
                :firstRequestDone="firstRequestDone"
                :maxHeight="maxHeightRT"
                @to-route="routeEdition($event.id)"
                @delete="
                    operatingAccountToDelete = $event;
                    deleteDialog = true;
                "
            ></RuleTable>
        </v-row>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="operatingAccountToDelete = undefined"
            @valid="deletePattern"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer ce tableau ?</h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";

import OPERATING_ACCOUNTS from "../../graphql/OperatingAccounts.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import RuleTable from "./RuleTable.vue";

@Component({
    components: {
        RuleTable,
    },
})
export class OperatingAccountTable extends Vue {
    firstRequestDone = false;

    loadingStateNext = true;

    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    operatingAccountCount: number = 0;

    search = "";

    filterCompany = null;

    get filterCompanyId() {
        return this.filterCompany?.title && this.filterCompany?.value
            ? this.filterCompany.value
            : null;
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                title: company.name,
            });
            companies.sort((a, b) => {
                if (a.title < b.title) return -1;
                if (a.title > b.title) return 1;
                return 0;
            });
        });
        companies.unshift({ value: "", title: "Toutes mes règles" });

        return companies;
    }

    get companyId() {
        return this.$store.state.user.company.id;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get where() {
        let OR = [];
        if (this.isRootProfile) {
            OR = [
                { companyScope: { accountingCompanyOwner: { id: this.companyId } } },
                { companyScope: { scopeSharingStatus: "VALIDATE", accountingCompany: null } },
                { companyScope: { scopeSharingStatus: "PENDING_VALIDATION" } },
            ];
        } else {
            OR = [
                { companyScope: { accountingCompanyOwner: { id: this.companyId } } },
                { companyScope: { scopeSharingStatus: "VALIDATE", accountingCompany: null } },
            ];
        }
        if (this.search) {
            return {
                AND: [
                    {
                        OR: [
                            { name_contains: this.search },
                            { clients_some: { name_contains: this.search } },
                        ],
                    },
                    {
                        OR,
                    },
                ],
            };
        }
        return { OR };
    }

    getWording(item) {
        return item.use ? this.$t("operatingAccount.use." + item.use) : "";
    }

    get maxHeightRT() {
        return "calc(100vh - 160px)";
        const innHeight = window.innerHeight;
        const vhHeight = (210 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    @Watch("search")
    onSearchModified(value) {
        this.items = [];
        this.pagination.page = 1;
        this.firstRequestDone = false;
    }

    @Apollo({
        query: OPERATING_ACCOUNTS,
        variables() {
            return {
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                where: this.where,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.firstRequestDone = true;
                    this.items.length = 0;
                    this.items.push(...data.operatingAccounts);
                    this.operatingAccountCount = data.operatingAccountsConnection.aggregate.count;
                } else {
                    this.items = [];
                    this.pagination.page = 1;
                    this.operatingAccountCount = 0;
                }
            }
        },
    })
    items: Array<any> = [];

    routeEdition(id) {
        this.$router.push({
            name: "operatingAccountSheet",
            params: {
                idSheet: id,
            },
        });
    }

    operatingAccountToDelete;
    deleteDialog = false;
    deleteLoading = false;

    async deletePattern() {
        this.deleteLoading = true;
        if (this.operatingAccountToDelete) {
            const deletedOA = await this.$apollo.mutate({
                mutation: gql`
                    mutation DeleteOperatingAccount($id: ID!) {
                        deleteOperatingAccount(where: { id: $id }) {
                            id
                            companyScopeId
                        }
                    }
                `,
                variables: {
                    id: this.operatingAccountToDelete.id,
                },
            });
            // await this.$apollo.mutate({
            //     mutation: gql`
            //         mutation DeleteCompanyScope($id: ID!) {
            //             deleteCompanyScope(where: { id: $id }) {
            //                 id
            //             }
            //         }
            //     `,
            //     variables: {
            //         id: deletedOA.data.deleteOperatingAccount.companyScopeId,
            //     },
            // });
            this.operatingAccountToDelete = undefined;
            this.refresh();
        }
        this.deleteDialog = false;
        this.deleteLoading = false;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger;
        }
    }
}

export default toNative(OperatingAccountTable);
</script>
